import React from 'react'
import Card from '../../../common/card/Card'

const RestrictDomains = () => {
  return (
    <Card title='Restrict Domains'>
      <div className='msync-restrict-domains'>
        <span>Add a list of permitted email domains (one per row)</span>
      </div>
    </Card>
  )
}

export default RestrictDomains
